// extracted by mini-css-extract-plugin
export default {"container":"menusvg_container__BMZ6L","active":"menusvg_active__u9fMI","close":"menusvg_close__1+BRD"};